import { render, staticRenderFns } from "./SmsAutomation.vue?vue&type=template&id=c976348e&scoped=true&"
import script from "./SmsAutomation.vue?vue&type=script&lang=ts&"
export * from "./SmsAutomation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c976348e",
  null
  
)

export default component.exports